var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tip",rawName:"v-tip",value:(_vm.title),expression:"title"}],staticClass:"sem-dot",style:(_vm.dotStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }